import {breakpoint} from "../utils/breakpoints.js";
import {gsap, ScrollTrigger} from "../utils/vendor.js";

let mm;

export default class BlogComponent {
    init() {
        if (ScrollTrigger.isTouch) {
            return;
        }

        mm = gsap.matchMedia();

        mm.add(breakpoint.l, () => {
            document.querySelectorAll(".js-blog").forEach(container => {
                gsap.to(container.querySelectorAll(".c-card"), {
                    x: () => container.offsetWidth - container.scrollWidth,
                    ease: "none",
                    scrollTrigger: {
                        trigger: container,
                        invalidateOnRefresh: true, // https://gsap.com/community/forums/topic/31585-refresh-does-not-work-when-resizing/
                        scrub: true,
                        pin: true,
                        end: "+=3000", // Rallenta l’animazione (più è alto il valore, più rallenta)
                    },
                });
            });
        });
    }

    beforeTransition() {
        /**
         * Se visito la home, poi un'altra pagina e poi torno in home,
         * rischio che mm.add() venga eseguita due volte!
         */
        mm?.revert();
    }
}
